import { PageHead } from "@/components/PageHead";
import { useProductPicker } from "@/modules/products/ProductPicker";

type Group = { g: number; name: string; perms: [number, string][] };

const GROUPS: Group[] = [
  { g: 100, name: "Live Data", perms: [[100, "Live Data"], [101, "Export CSV"]] },
  { g: 200, name: "Flashing", perms: [[200, "Flash application"], [201, "Flash bootloader"]] },
  { g: 300, name: "Configuration", perms: [[300, "Read config"], [301, "Write config"]] },
];

/** Permission map — the vocabulary a product authors, per tool.
 *
 *  Fabric STORES this and never interprets it: the same numeric id means
 *  different things in different tools, which is why it is scoped by tool slug
 *  and why nothing outside the product may reason about the numbers.
 */
export function PermissionMapPage() {
  const { picker } = useProductPicker();

  return (
    <div className="mpage on">
      <PageHead
        eyebrow="Products · Permission map"
        title="Permission map"
        desc="The permission vocabulary for a product, per tool. Fabric stores what the product authors and never interprets it."
        right={picker}
      />

      <div className="panel panel-pad">
        <div className="section-label">uds_tool</div>
        <div className="cap" style={{ marginBottom: 10 }}>
          Groups are organisational labels and are not themselves checkable; only the permissions inside them
          are. Removing one <strong>deprecates</strong> it rather than deleting it, so existing grants survive —
          and grants point at a stable row, never at the display name, so renaming one breaks nothing.
        </div>
        {GROUPS.map((grp) => (
          <div key={grp.g} style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 12.5, fontWeight: 700 }}>
              <span className="mono muted">{grp.g}</span> {grp.name}
            </div>
            {grp.perms.map(([id, label]) => (
              <div key={id} style={{ display: "flex", gap: 10, padding: "4px 0 4px 18px", fontSize: 12.5 }}>
                <span className="mono muted" style={{ width: 44 }}>{id}</span>
                <span>{label}</span>
              </div>
            ))}
          </div>
        ))}
        <button type="button" className="btn teal sm">Edit map</button>
      </div>
    </div>
  );
}
